import React from "react"

export default function Spacer({ className = "" }) {
    return <div className={`spacer ${className}`} />
}
